import {
    SET_COUNTRY_LIST,
    SET_PAGINATION,
    SET_PERMISSION_AVAILABLE_PROJECTS,
    SET_PERMISSION_AVAILABLE_ROLES,
    SET_PERMISSION_GROUPS,
    SET_PERMISSION_PRIORITY,
    SET_PROJECTS_LIST,
} from '../actions/generalData';
import type { GeneralDataAction, GeneralDataState } from '../types/generalData';

export const initialState: GeneralDataState = {
    projectsList: [],
    countryList: [],
    pageSize: 10,
    permissionGroups: {},
    permissionAvailableRoles: [],
    permissionAvailableProjects: [],
    permissionRolePriority: {},
};

export const generalDataReducer = <TState extends GeneralDataState>(state: TState, action: GeneralDataAction): TState => {
    switch (action.type) {
        case SET_PROJECTS_LIST:
            return { ...state, projectsList: action.payload };
        case SET_COUNTRY_LIST:
            return { ...state, countryList: action.payload };
        case SET_PAGINATION:
            return { ...state, pageSize: action.payload };
        case SET_PERMISSION_GROUPS:
            return { ...state, permissionGroups: action.payload };
        case SET_PERMISSION_AVAILABLE_ROLES:
            return { ...state, permissionAvailableRoles: action.payload };
        case SET_PERMISSION_AVAILABLE_PROJECTS:
            return { ...state, permissionAvailableProjects: action.payload };
        case SET_PERMISSION_PRIORITY:
            return { ...state, permissionRolePriority: action.payload };
        default:
            return state;
    }
};
